import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function VendorSection() {
  const benefits = ['Access to fully-equipped commercial kitchen', 'Built-in hungry community audience', 'Marketing and promotional support', 'Low-risk, low-fee pop-up model', 'Mentorship from experienced restaurateurs'];
  return <section id="vendors" className="py-20 lg:py-32 bg-foodCream" data-id="element-240" data-mp="nc7yyp7szrtg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-241" data-mp="ne2ka4mzlly2">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-242" data-mp="rd1i75aawig0">
          {/* Pitch */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-243" data-mp="wcnyjnlfeet1">
            <div className="inline-block bg-foodGold text-foodMaroon font-bold px-4 py-1 border-2 border-foodMaroon mb-6 rotate-[-2deg]" data-id="element-244" data-mp="8nbqir1u4csb">
              For Chefs & Food Creators
            </div>
            <h2 className="text-5xl md:text-6xl font-extrabold uppercase mb-6" data-id="element-245" data-mp="3qint69zuzplx">
              Cook with Us. <br data-id="element-246" data-mp="3ql1nuhqmmzsy" />
              <span className="text-foodTomato" data-id="element-247" data-mp="3lrp7euw3pzba">Grow Your Brand.</span>
            </h2>
            <p className="text-xl font-medium mb-8" data-id="element-248" data-mp="3gsvup4on2cc6">
              Whether you're testing a new concept, expanding your catering
              business, or ready for your first pop-up, The Food Pavilion
              provides the launchpad.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-249" data-mp="36t51r7fq85e7">
              {benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-250" data-mp="32tmrd5lj7cpm" data-mpi={idx}>
                  <CheckCircle2 className="text-foodOrange shrink-0 mt-1" size={24} data-id="element-251" data-mp="2xujonrt0xikt" />
                  <span className="text-lg font-bold" data-id="element-252" data-mp="110yjgixy013i">{benefit}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Form */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-foodCard border-4 border-foodMaroon p-8 shadow-[12px_12px_0px_0px_#34302A]" data-id="element-253" data-mp="1f679c7s4br4n">
            <h3 className="text-3xl font-extrabold uppercase mb-2" data-id="element-254" data-mp="1yuppjzv5bu77">
              Apply to Vend
            </h3>
            <p className="font-medium text-foodMaroon/70 mb-6" data-id="element-255" data-mp="22vt6kpoxjwa0">
              Applications are reviewed on a rolling basis. Fill out the form
              below and we'll be in touch.
            </p>
            <div className="border-2 border-foodMaroon bg-white overflow-hidden" data-id="element-256" data-mp="1tv3g81ifuy3o">
              <iframe title="Vendor application form" src="https://airtable.com/embed/appI2I45tiqNfvkj1/pagJJ1u3pGwR3IiNN/form" className="w-full h-[640px] block" frameBorder="0" data-id="element-257" data-mp="dhd6of8jvhmn" />
            </div>
            <a href="https://airtable.com/appI2I45tiqNfvkj1/pagJJ1u3pGwR3IiNN/form" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-foodOrange text-white font-bold text-lg py-4 border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#34302A] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0px_0px_#34302A] transition-all mt-6" data-id="element-258" data-mp="5ydqeigdy67i">
              Open Application in New Tab
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}